module.exports = __webpack_public_path__ + "static/img/101380.0223d797.png";